import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserSettings, detectUserTimezone } from '../services/settingsService';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const userSettings = await getUserSettings();
      setSettings(userSettings);
    } catch (error) {
      console.error('Error loading settings in context:', error);
      // Fallback to detected timezone
      setSettings({
        timezone: detectUserTimezone(),
        date_format: 'MMM DD, YYYY',
        currency_display: 'symbol',
        theme: 'light',
      });
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = async () => {
    await loadSettings();
  };

  const value = {
    settings,
    loading,
    refreshSettings,
    timezone: settings?.timezone || detectUserTimezone(),
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
